import { render, staticRenderFns } from "./Savannah.vue?vue&type=template&id=b46fd1be&scoped=true"
import script from "./Savannah.vue?vue&type=script&lang=js"
export * from "./Savannah.vue?vue&type=script&lang=js"
import style0 from "./Savannah.vue?vue&type=style&index=0&id=b46fd1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46fd1be",
  null
  
)

export default component.exports